export enum ActivityStreamSpecialPaymentProposalPropertyType {
  CurrentApprover = 'CurrentApprover'
}
